import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema } from 'tnx-shared';
import { ExecutionPointerService } from 'tnx-admin-service/workflowcore/executionpointer/services';
@Component({
	selector: 'executionpointer',
	templateUrl: './executionpointer.component.html',
	styleUrls: ['./executionpointer.component.scss'],
	providers: [ComponentContextService],
})
export class ExecutionPointerComponent extends DataListBase implements OnInit, AfterViewInit {
	@ViewChild('crudList', { static: false }) crudList: CrudListComponent;
	searchSchema: any = {};
	searchData: any = {};
	constructor(
		protected _injector: Injector,
		protected _executionPointerService: ExecutionPointerService,
	) {
		super(_injector);
	}

	ngOnInit() {
		this.setting.baseService = this._executionPointerService;
		this.setting.modelSchemas = [
			new ModelSchema({ field: 'persistenceId', dataType: 'int', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'active', dataType: 'boolean', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'retryCount', dataType: 'int', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'endTime', dataType: 'date', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'eventData', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'eventKey', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'eventName', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'eventPublished', dataType: 'boolean', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'persistenceData', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'sleepUntil', dataType: 'date', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'startTime', dataType: 'date', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'stepId', dataType: 'int', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'stepName', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'workflowId', dataType: 'int', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'children', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'contextItem', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'predecessorId', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'outcome', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'scope', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'status', dataType: 'int', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' }),
			new ModelSchema({ field: 'code', name: '', fullName: '', description: '' })
		];

		this.setting.cols = [
			new ColumnSchemaBase({ field: 'persistenceId' }),
			new ColumnSchemaBase({ field: 'active' }),
			new ColumnSchemaBase({ field: 'retryCount' }),
			new ColumnSchemaBase({ field: 'endTime' }),
			new ColumnSchemaBase({ field: 'eventData' }),
			new ColumnSchemaBase({ field: 'eventKey' }),
			new ColumnSchemaBase({ field: 'eventName' }),
			new ColumnSchemaBase({ field: 'eventPublished' }),
			new ColumnSchemaBase({ field: 'persistenceData' }),
			new ColumnSchemaBase({ field: 'sleepUntil' }),
			new ColumnSchemaBase({ field: 'startTime' }),
			new ColumnSchemaBase({ field: 'stepId' }),
			new ColumnSchemaBase({ field: 'stepName' }),
			new ColumnSchemaBase({ field: 'workflowId' }),
			new ColumnSchemaBase({ field: 'children' }),
			new ColumnSchemaBase({ field: 'contextItem' }),
			new ColumnSchemaBase({ field: 'predecessorId' }),
			new ColumnSchemaBase({ field: 'outcome' }),
			new ColumnSchemaBase({ field: 'scope' }),
			new ColumnSchemaBase({ field: 'status' }),
			new ColumnSchemaBase({ field: 'currentStateCode' }),
			new ColumnSchemaBase({ field: 'code' })
		];

		super.ngOnInit();
	}
}

